import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GuestGuard } from '../core/guards/guest.guard';

import { LoginV2Component } from '../login/loginV2/login.component';
import { ForgotPasswordComponent } from '../login/forgot-password/forgot-password.component';
import { LandingComponent } from '../unattached/landing/landing.component';
import { SignupV2Component } from '../login/signupV2/signup.component';
import { ReceiptComponent } from '../unattached/receipt/receipt.component';
import { OrderReceiptComponent } from '../unattached/order-receipt/order-receipt.component';
import { SupportComponent } from '../unattached/support/support.component';
import { ConfirmAccountComponent } from '../login/confirm-account/confirm-account.component';
import { TermsComponent } from '../unattached/terms/terms.component';

import { ConfirmAuthComponent } from '../author-dashboard/confirm-auth/confirm-auth.component';
import { GiveawaysComponent } from '../giveaways/giveaways.component';
import { MembershipComponent } from '../membership/membership.component';
import { ConfirmGiveawayEmailComponent } from '../giveaways/confirm-giveaway-email/confirm-giveaway-email.component';
import { AuthorizeAppComponent } from '../author-dashboard/authorize-app/authorize-app.component';

export const routes: Routes = [
	{ path: '', component: LandingComponent },

	{ path: 'giveaways/:siteAdvertId', component: GiveawaysComponent, data: { title: 'Giveaways' } },
	{
		path: 'giveaways/confirm/:siteAdvertId/:email',
		component: ConfirmGiveawayEmailComponent,
		data: { title: 'Confirm Giveaway Email' },
	},

	{ path: 'subscriptions', redirectTo: '/membership' },
	{ path: 'subscriptions/:membershipLevel', redirectTo: '/membership' },
	{
		path: 'author-dashboard',
		loadChildren: () => import('../author-dashboard/author-dashboard.module').then((m) => m.AuthorDashboardModule),
	},
	{ path: 'confirm-account/:author/:code', component: ConfirmAccountComponent, data: { title: 'Confirm Account' } },
	{
		path: 'features',
		loadChildren: () => import('../features/features.module').then((m) => m.FeaturesModule),
		canActivate: [GuestGuard],
	},
	{ path: 'features2', redirectTo: '/features' },
	{
		path: 'promo-stacks',
		loadChildren: () => import('../promo-stacks/promo-stacks.module').then((m) => m.PromoStackModule),
		canActivate: [GuestGuard],
	},
	{
		path: 'events',
		loadChildren: () => import('../events/events.module').then((m) => m.EventsModule),
		canActivate: [GuestGuard],
	},
	{ path: 'forgot-password', component: ForgotPasswordComponent, data: { title: 'Forgot Password' } },
	{ path: 'login', component: LoginV2Component, data: { title: 'Login' } },
	{ path: 'receipt/:feature', component: ReceiptComponent, data: { title: 'Receipt' } },
	{ path: 'order-receipt/:order', component: OrderReceiptComponent, data: { title: 'Order Receipt' } },
	{ path: 'reset-password/:authorLink/:resetCode', component: ForgotPasswordComponent, data: { title: 'Reset Password' } },
	{ path: 'signup', component: SignupV2Component, data: { title: 'Signup' } },
	{ path: 'support', component: SupportComponent, data: { title: 'Support' } },
	{ path: 'terms', component: TermsComponent, data: { title: 'Terms of Service' } },
	{ path: 'confirm-auth', component: ConfirmAuthComponent, data: { title: 'Auth Confirmation' } },
	{ path: 'authorize-app', component: AuthorizeAppComponent, data: { title: 'Authorize App' } },
	{ path: 'membership', component: MembershipComponent, data: { title: 'Membership' } },
	{ path: '**', redirectTo: '/features' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
	exports: [RouterModule],
})
export class AppRoutingModule {

}
